import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  message,
  Modal,
  ModalProps,
  Row
} from 'antd'
import { useNavigate } from 'react-router-dom'

import { usePatientsServiceMarkAsPatientEndpoint } from 'src/api/queries'
import { ApiError } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'
import { formErrorHandler } from 'src/utils'

type Props = {
  personId?: string
  onClose: () => void
} & ModalProps

export const RegisterPatientModal = ({
  personId,
  onClose,
  ...props
}: Props) => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const [form] = Form.useForm()

  const { mutate, isPending } = usePatientsServiceMarkAsPatientEndpoint({
    onSuccess: () => {
      message.success(t('persons.patient_registered_successfully'))
      navigate(paths.patients.details(String(personId)))
    },
    onError: (e: ApiError) => formErrorHandler(e.body.errors)
  })

  const onSubmit = async () => {
    const values = await form.validateFields()

    mutate({ id: String(personId), requestBody: { ...values } })
  }

  return (
    <Modal
      open
      title={t('persons.register_as_patient')}
      onCancel={onClose}
      maskClosable={false}
      footer={
        <Flex gap={8}>
          <Button onClick={onClose}>{t('common.cancel')}</Button>
          <Button type="primary" loading={isPending} onClick={onSubmit}>
            {t('persons.save')}
          </Button>
        </Flex>
      }
      {...props}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={t('common.sime_code')}
              name="simeCode"
              rules={requiredRules}
            >
              <Input placeholder={t('common.sime_code')} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label={t('common.tarv_code')} name="tarvCode">
              <Input placeholder={t('common.tarv_code')} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
